import React from 'react'
import { List, Header } from 'semantic-ui-react'
import Countdown from "react-countdown-now"



const About = () => (
    <List divided relaxed ordered>
        <h2><font color='orange'>About CodeDialer</font></h2>
        <p><b>CodeDialer</b> is a <b>USSD code dialer</b>, made for users of all mobile cell operator services, e.g. payments. It features more than <i>50 USSD codes</i> from (Zimbabwean services) but a USSD from <b>any mobile operator</b> can be added.</p>

        <h3>Features:</h3>

        <List.Item>
            <i>Most recently used USSD list</i>: <b>yes</b>
        </List.Item>

        <List.Item>
            <i>Contact USSD actions</i>: <b>yes</b>
        </List.Item>

        <List.Item>
            <i>Editable USSD provider list</i>: <b>no</b>
        </List.Item>

        <List.Item>
            <i>Editable USSD list</i>: <b>yes</b>
        </List.Item>
        <List.Item>
            <i>Reviews</i>: <b>yes</b>
        </List.Item>
        <List.Item>
            <i>Listing Images</i>: <b>yes</b>
        </List.Item>

    </List>
)

export default About
